import React from "react";
import {NavContext} from '../providers';

function useNav() {
    return React.useContext(NavContext);
}

export {useNav}
